import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { toDayjs } from 'src/utils/date';

export const DateView = ({ value, timezone }: CustomAttributeReadProps) => {
  const date = toDayjs(getKindLikeValueSafely(value, 'date'));

  if (!date) {
    return <EmptyValue />;
  }

  const zoned = timezone ? date.tz(timezone) : date;
  return <AttributeText>{zoned.format('MMM D, YYYY')}</AttributeText>;
};

export const DateTimeView = ({ value, timezone }: CustomAttributeReadProps) => {
  const date = toDayjs(getKindLikeValueSafely(value, 'date_time'));

  if (!date) {
    return <EmptyValue />;
  }

  const zoned = timezone ? date.tz(timezone) : date;
  return <AttributeText>{zoned.format('MMM D, YYYY h:mm A')}</AttributeText>;
};
